import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/AssetSubCategoryController/CreateAssetSubCategoryController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateAssetSubCategory({ asset, onClose, onSuccess, assetCategories }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ AssetCategoryID: '', SubCategoryName: '', dec_DepRate: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    useEffect(() => {
        if (asset) {
            setFormData({
                AssetCategoryID: asset.AssetCategoryID,
                SubCategoryName: asset.SubCategoryName,
                dec_DepRate: asset.dec_DepRate
            });
            setErrors({});
        } else {
            setFormData({ AssetCategoryID: '', SubCategoryName: '', dec_DepRate: '' }); // Clear form data when switching to add mode
            setErrors({});
        }
    }, [asset, assetCategories]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault();
        if (asset) {
            formData.ID = asset.ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        }, () => {
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="assetSubCategoriesModal" tabIndex="-1" aria-labelledby="assetSubCategoriesModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="assetSubCategoriesModalLabel">{asset ? "Edit Asset Sub Category" : "Add Asset Sub Category"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{"marginLeft":"5px","marginRight":"0px","marginTop":"10px"}}>
                                    <label htmlFor="AssetCategoryID" className="col-sm-2 col-form-label">Asset Category:</label>
                                    <div className="col-sm-4">
                                        <select
                                            name="AssetCategoryID"
                                            className='form-control'
                                            value={formData.AssetCategoryID}
                                            onChange={handleFieldChange}
                                        >
                                            <option value="0">Select Asset Category</option>
                                            {assetCategories.map((category) => (
                                                <option key={category.ID} value={category.ID}>
                                                    {category.AssetCategory}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.AssetCategoryID && <div style={{ color: 'red' }}>{errors.AssetCategoryID}</div>}
                                    </div>
                                    <label htmlFor="SubCategoryName" className="col-sm-2 col-form-label">Sub Category:</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="SubCategoryName"
                                            value={formData.SubCategoryName}
                                            onChange={handleFieldChange}
                                        />
                                        {errors.SubCategoryName && <div style={{ color: 'red' }}>{errors.SubCategoryName}</div>}
                                    </div>
                                </div>
                                <div className="row mb-3" style={{"marginLeft":"5px","marginRight":"0px"}}>
                                    <label htmlFor="dec_DepRate" className="col-sm-2 col-form-label">Depn %:</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="dec_DepRate"
                                            value={formData.dec_DepRate}
                                            onChange={handleFieldChange}
                                        />
                                        {errors.dec_DepRate && <div style={{ color: 'red' }}>{errors.dec_DepRate}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                <i className="icofont-save" aria-hidden="true"> {asset ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button"  data-dismiss="modal" aria-label="Close">
                                <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateAssetSubCategory;
